/**
 * Beta / GA release toggles. Set in `.env` (Vite: `VITE_*` only).
 * Shown by default so local dev and beta deploys see it without extra config.
 * For full launch: set `VITE_SHOW_BETA_BADGE=false` (or `0`).
 */
const raw = import.meta.env.VITE_SHOW_BETA_BADGE;
export const showBetaBadge = raw !== 'false' && raw !== '0';

export const betaBadgeLabel =
  (import.meta.env.VITE_BETA_BADGE_LABEL as string | undefined)?.trim() || 'Beta';

export const betaBadgeDescription =
  (import.meta.env.VITE_BETA_BADGE_DESCRIPTION as string | undefined)?.trim() ||
  "You're using the beta version of Five AI. A full public release is planned in the coming months — thank you for helping us improve.";
